import Vue from 'vue';
import { Plugins } from "./plugins";

const register = () => {

  Vue.directive('acl', {
    bind: function(el, binding, vNode) {
      const resourceName = binding.arg;
      const modifiers = Object.keys(binding.modifiers);
      if (modifiers.length !== 1) {
        throw "Acl Behavior error";
      }
      const behaviors = modifiers;
      const params = Object.assign({}, binding.value);
      const permission = Plugins.check(resourceName, behaviors, params);
      const disabled_elems = ['BUTTON', 'INPUT', 'OPTION', 'FIELDSET', 'OPTGROUP', 'TEXTAREA'];
      if (!permission) {
        if (disabled_elems.includes(vNode.elm.nodeName)) {
          vNode.elm.disabled = true;
        } else {
          vNode.elm.style.visibility = 'hidden';
        }
      }
    }
  });
};

export const directives = {
  register
};
